import { Component } from 'preact'
import { connect } from 'unistore/preact'

import FadingRouter from '../fading-router'
import MembershipStep from '../components/signup-flow/step-membership'
import WizardStep from '../components/signup-flow/step-wizard'
import PaymentStep from '../components/signup-flow/step-payment'
import ResultStep from '../components/signup-flow/step-result'
import { resetSignUp } from '../components/signup-flow/actions'
import Redirect from '../components/redirect'

class SignUp extends Component {
  componentWillUnmount () {
    this.props.resetSignUp()
  }

  onRouteChange (e) {
    if (!e.previous) return

    const prev = e.previous.split('?')[0]
    const curr = e.url.split('?')[0]

    if (prev !== curr) window.scrollTo(0, 0)
  }

  render ({
    onStartChange,
    setSidebar,
    delay
  }) {
    return (
      <FadingRouter onStartChange={onStartChange} delay={delay} onChange={this.onRouteChange}>
        <PaymentStep path='/bli-medlem/betalning' />
        <ResultStep path='/bli-medlem/resultat' />
        <MembershipStep path='/bli-medlem/medlemskap' />
        <WizardStep
          path='/bli-medlem/guide'
          setSidebar={setSidebar}
        />
        <Redirect path='/bli-medlem' to='/bli-medlem/guide' />
      </FadingRouter>
    )
  }
}

export default connect(null, { resetSignUp })(SignUp)



// WEBPACK FOOTER //
// ./routes/sign-up.js